module.exports = __webpack_public_path__ + "assets/img/maleHead.2456b11a.png";